/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobAckDetails = core.serialization.object({
    info: core.serialization.string().optional(),
    progress: core.serialization.number().optional(),
    estimatedCompletionAt: core.serialization.date().optional(),
});
